import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Moon, Home, Sparkles } from 'lucide-react';
export function Transformation() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-[#F5F0E8]" data-id="element-476">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-478">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2F4538] mb-6" data-id="element-479">
            ¿Qué vas a lograr con este sistema?
          </h2>
          <p className="text-xl text-[#1a1a1a]/70 max-w-3xl mx-auto" data-id="element-480">
            Si seguís el Protocolo de 7 Días y usás el sistema de forma
            consistente, esto es lo que va a pasar:
          </p>
        </motion.div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-8 sm:before:ml-[50%] before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-[#D4AF37]/0 before:via-[#D4AF37] before:to-[#D4AF37]/0" data-id="element-481">
          {/* Semana 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-482">
            <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#F5F0E8] bg-[#2F4538] text-[#D4AF37] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-483">
              <Moon className="w-6 h-6" data-id="element-484" />
            </div>
            <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white p-6 sm:p-8 rounded-3xl shadow-sm border border-[#D4AF37]/20" data-id="element-485">
              <h3 className="font-bold text-[#B4A7D6] text-xl mb-4" data-id="element-486">
                ✅ EN LA PRIMERA SEMANA:
              </h3>
              <ul className="space-y-3 text-[#1a1a1a]/80" data-id="element-487">
                <li data-id="element-488">
                  <strong className="text-[#2F4538]" data-id="element-489">
                    💤 Vas a dormir mejor.
                  </strong>{' '}
                  Menos vueltas en la cama, menos despertares a las 3am.
                </li>
                <li data-id="element-490">
                  <strong className="text-[#2F4538]" data-id="element-491">
                    🧘‍♀️ Vas a sentir tu cuerpo más liviano.
                  </strong>{' '}
                  Como si te hubieran sacado un peso invisible.
                </li>
                <li data-id="element-492">
                  <strong className="text-[#2F4538]" data-id="element-493">
                    😌 Tu nivel de ansiedad va a bajar.
                  </strong>{' '}
                  Ya no vas a tener el pecho apretado todo el día.
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Mes 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-494">
            <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#F5F0E8] bg-[#8B9D83] text-[#F5F0E8] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-495">
              <Home className="w-6 h-6" data-id="element-496" />
            </div>
            <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white p-6 sm:p-8 rounded-3xl shadow-sm border border-[#D4AF37]/20" data-id="element-497">
              <h3 className="font-bold text-[#B4A7D6] text-xl mb-4" data-id="element-498">
                ✅ EN EL PRIMER MES:
              </h3>
              <ul className="space-y-3 text-[#1a1a1a]/80" data-id="element-499">
                <li data-id="element-500">
                  <strong className="text-[#2F4538]" data-id="element-501">
                    🏠 Tu casa va a sentirse diferente.
                  </strong>{' '}
                  Menos discusiones, mejor energía, ambiente más tranquilo.
                </li>
                <li data-id="element-502">
                  <strong className="text-[#2F4538]" data-id="element-503">
                    💪 Vas a recuperar tu poder personal.
                  </strong>{' '}
                  Ya no vas a absorber la energía de todos como una esponja.
                </li>
                <li data-id="element-504">
                  <strong className="text-[#2F4538]" data-id="element-505">
                    🌸 Vas a tener una herramienta REAL.
                  </strong>{' '}
                  Cuando tengas un día horrible, sabés exactamente qué hacer.
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Mes 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-506">
            <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#F5F0E8] bg-[#B4A7D6] text-white shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-507">
              <Sparkles className="w-6 h-6" data-id="element-508" />
            </div>
            <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white p-6 sm:p-8 rounded-3xl shadow-sm border border-[#D4AF37]/20" data-id="element-509">
              <h3 className="font-bold text-[#B4A7D6] text-xl mb-4" data-id="element-510">
                ✅ EN 3 MESES:
              </h3>
              <ul className="space-y-3 text-[#1a1a1a]/80" data-id="element-511">
                <li data-id="element-512">
                  <strong className="text-[#2F4538]" data-id="element-513">
                    ✨ Los rituales van a ser parte de tu vida.
                  </strong>{' '}
                  Tan natural como lavarte los dientes.
                </li>
                <li data-id="element-514">
                  <strong className="text-[#2F4538]" data-id="element-515">
                    🎯 Vas a saber EXACTAMENTE qué necesitás.
                  </strong>{' '}
                  Ya no dependés del PDF. Lo tenés internalizado.
                </li>
                <li data-id="element-516">
                  <strong className="text-[#2F4538]" data-id="element-517">
                    💰 Cambios en tu prosperidad.
                  </strong>{' '}
                  Más oportunidades, mejores decisiones, menos bloqueos.
                </li>
                <li data-id="element-518">
                  <strong className="text-[#2F4538]" data-id="element-519">
                    🛡️ Tu energía va a estar BLINDADA.
                  </strong>{' '}
                  Ya no te afecta cualquier cosa. Estás protegida.
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}